(function () {
  'use strict';

  // ── Config ───────────────────────────────────────────────────────────────
  // Entries close 11:59 PM AEST Sunday 23 August 2026.
  // Brisbane (QLD) does not observe daylight saving. AEST = UTC+10 year-round.
  // Flag to Kalani: countdown and all close-date copy on this page uses AEST (UTC+10).
  // Read from the countdown section's setting so the timer and its label can
  // never drift apart again. The literal is only a fallback for the case where
  // the countdown section has been removed from the page.
  var CD_EL         = document.querySelector('[data-afta-close]');
  var CLOSE_ISO     = (CD_EL && CD_EL.getAttribute('data-afta-close')) || '2026-08-23T23:59:00+10:00';
  var CLOSE_DATE    = new Date(CLOSE_ISO);
  if (isNaN(CLOSE_DATE.getTime())) {
    CLOSE_ISO  = '2026-08-23T23:59:00+10:00';
    CLOSE_DATE = new Date(CLOSE_ISO);
  }
  var LIST_ID       = 'SeW4Xc';   // AFTA Giveaway 2026 – created 2026-07-24
  var COMPANY_ID    = 'UinWNa';
  var CUSTOM_SOURCE = 'AFTA Giveaway 2026';

  // ── Shared: closed-state ─────────────────────────────────────────────────
  function markClosed() {
    document.body.classList.add('afta-giveaway-closed');
    var formSection = document.querySelector('.afta-form-section');
    if (formSection) formSection.classList.add('afta-form-section--closed');
  }

  // ── Countdown ────────────────────────────────────────────────────────────
  function initCountdown() {
    var liveEl   = document.querySelector('.afta-cd__live');
    var staticEl = document.querySelector('.afta-cd__static');
    var closedEl = document.querySelector('.afta-cd__closed');
    if (!liveEl) return;

    var daysEl  = liveEl.querySelector('[data-unit="days"]');
    var hoursEl = liveEl.querySelector('[data-unit="hours"]');
    var minsEl  = liveEl.querySelector('[data-unit="minutes"]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = CLOSE_DATE.getTime() - Date.now();
      if (diff <= 0) {
        liveEl.classList.remove('afta-cd--running');
        if (closedEl) closedEl.classList.add('afta-cd--show');
        markClosed();
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      if (daysEl)  daysEl.textContent  = d;
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minsEl)  minsEl.textContent  = pad(m);
    }

    // Already closed on load?
    if (Date.now() >= CLOSE_DATE.getTime()) {
      if (closedEl) closedEl.classList.add('afta-cd--show');
      markClosed();
      return;
    }

    // Start live countdown
    if (staticEl) staticEl.classList.add('afta-cd--hidden');
    liveEl.classList.add('afta-cd--running');
    tick();
    // Update every 30 s — no seconds displayed, 30 s is sufficient
    setInterval(tick, 30000);
  }

  // ── Hero video ───────────────────────────────────────────────────────────
  function initVideo() {
    var video = document.querySelector('.afta-hero__video');
    if (!video) return;
    video.addEventListener('canplay', function onCanPlay() {
      video.classList.add('afta-hero__video--loaded');
      video.removeEventListener('canplay', onCanPlay);
    });
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  // ── Form ─────────────────────────────────────────────────────────────────
  function initForm() {
    var form = document.getElementById('afta-entry-form');
    if (!form) return;

    var submitBtn   = form.querySelector('.afta-form__submit');
    var successEl   = document.getElementById('afta-success');
    var globalErrEl = form.querySelector('.afta-form__global-err');

    function normPhone(raw) {
      var s = raw.replace(/[\s\-().]/g, '');
      if (/^0[45]\d{8}$/.test(s)) return '+61' + s.slice(1);
      if (/^\+61[45]\d{8}$/.test(s)) return s;
      return null;
    }

    function setErr(input, msgEl, msg) {
      input.classList.add('afta-form__input--err');
      if (msgEl) { msgEl.textContent = msg; msgEl.classList.add('afta-form__err-msg--on'); }
    }
    function clrErr(input, msgEl) {
      input.classList.remove('afta-form__input--err');
      if (msgEl) msgEl.classList.remove('afta-form__err-msg--on');
    }

    function validate() {
      var ok = true;

      var fn = form.querySelector('#afta-fn'), fnE = form.querySelector('#afta-fn-err');
      clrErr(fn, fnE);
      if (!fn.value.trim()) { setErr(fn, fnE, 'First name is required.'); ok = false; }

      var ln = form.querySelector('#afta-ln'), lnE = form.querySelector('#afta-ln-err');
      clrErr(ln, lnE);
      if (!ln.value.trim()) { setErr(ln, lnE, 'Last name is required.'); ok = false; }

      var em = form.querySelector('#afta-em'), emE = form.querySelector('#afta-em-err');
      clrErr(em, emE);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim())) {
        setErr(em, emE, 'Please enter a valid email address.'); ok = false;
      }

      var ph = form.querySelector('#afta-ph'), phE = form.querySelector('#afta-ph-err');
      clrErr(ph, phE);
      if (!normPhone(ph.value.trim())) {
        setErr(ph, phE, 'Enter a valid AU mobile (e.g. 0412 345 678).'); ok = false;
      }

      var sms = form.querySelector('#afta-sms'), smsE = form.querySelector('#afta-sms-err');
      if (smsE) smsE.classList.remove('afta-form__err-msg--on');
      if (!sms.checked) {
        if (smsE) { smsE.textContent = 'SMS consent is required to enter.'; smsE.classList.add('afta-form__err-msg--on'); }
        ok = false;
      }

      var eml = form.querySelector('#afta-eml'), emlE = form.querySelector('#afta-eml-err');
      if (emlE) emlE.classList.remove('afta-form__err-msg--on');
      if (!eml.checked) {
        if (emlE) { emlE.textContent = 'Email consent is required to enter.'; emlE.classList.add('afta-form__err-msg--on'); }
        ok = false;
      }

      return ok;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (globalErrEl) globalErrEl.classList.remove('afta-form__global-err--on');
      if (!validate()) return;

      submitBtn.disabled = true;
      var orig = submitBtn.textContent;
      submitBtn.textContent = 'Entering\u2026';

      var phone = normPhone(form.querySelector('#afta-ph').value.trim());

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: CUSTOM_SOURCE,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email:        form.querySelector('#afta-em').value.trim(),
                  phone_number: phone,
                  first_name:   form.querySelector('#afta-fn').value.trim(),
                  last_name:    form.querySelector('#afta-ln').value.trim()
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: LIST_ID } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2026-04-15' },
        body: JSON.stringify(payload)
      })
      .then(function (res) {
        if (res.status === 202) {
          form.style.display = 'none';
          if (successEl) successEl.classList.add('afta-form__success--on');
        } else {
          return res.json().then(function (body) {
            var detail = (body.errors && body.errors[0] && body.errors[0].detail) || ('Status ' + res.status);
            throw new Error('[Klaviyo ' + res.status + '] ' + detail);
          });
        }
      })
      .catch(function (err) {
        submitBtn.disabled = false;
        submitBtn.textContent = orig;
        if (globalErrEl) {
          globalErrEl.textContent = 'Something went wrong. Please try again.';
          globalErrEl.classList.add('afta-form__global-err--on');
        }
        console.error('[AFTA Form]', err.message || err);
      });
    });
  }

  // ── Boot ─────────────────────────────────────────────────────────────────
  function boot() { initCountdown(); initVideo(); initForm(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
